import { createContext } from 'react';

const IsMobileContext = createContext();

export default IsMobileContext;